import React from 'react';
import { trackEvent } from '../services/analyticsService';

interface DemoConversionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSignUp: () => void;
  onSignIn: () => void;
}

const DemoConversionModal: React.FC<DemoConversionModalProps> = ({
  isOpen,
  onClose,
  onSignUp,
  onSignIn
}) => {

  const handleSignUp = () => {
    trackEvent('demo_conversion_signup_clicked', {
      modal_location: 'conversion_modal',
      demo_session: true,
    });
    onSignUp();
  };

  const handleSignIn = () => {
    trackEvent('demo_conversion_signin_clicked', {
      modal_location: 'conversion_modal',
      demo_session: true,
    });
    onSignIn();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[9999] p-3 sm:p-4">
      <div className="bg-gradient-to-br from-system-dark to-system-gray border-2 border-yellow-500/50 rounded-lg p-4 sm:p-6 max-w-md w-full max-h-[90vh] overflow-y-auto animate-scale-in">
          {/* Header */}
          <div className="text-center mb-4 sm:mb-6">
            <div className="text-3xl sm:text-4xl mb-2 sm:mb-3">🎮</div>
            <h2 className="text-yellow-400 font-orbitron font-black text-lg sm:text-xl uppercase mb-2">
              Demo Mode Active
            </h2>
            <p className="text-gray-300 font-rajdhani text-xs sm:text-sm">
              You're making great progress! Sign up to start your real journey with all features unlocked.
            </p>
          </div>

          {/* Benefits */}
          <div className="bg-black/40 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6 border border-yellow-500/20">
            <h3 className="text-yellow-400 font-orbitron font-bold text-xs sm:text-sm uppercase mb-2 sm:mb-3">
              What you'll get:
            </h3>
            <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-300">
              <li className="flex items-center gap-2">
                <span className="text-green-400 text-sm">✓</span>
                <span>Start your real journey from the beginning</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-green-400 text-sm">✓</span>
                <span>Access to AI quest generation</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-green-400 text-sm">✓</span>
                <span>Advanced statistics and analytics</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-green-400 text-sm">✓</span>
                <span>Custom backgrounds and themes</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
            <button
              onClick={onClose}
              className="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 font-orbitron font-bold text-xs sm:text-sm uppercase tracking-wider rounded transition-all"
            >
              Continue Demo
            </button>
            <button
              onClick={handleSignIn}
              className="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-2 bg-blue-600 hover:bg-blue-500 text-white font-orbitron font-bold text-xs sm:text-sm uppercase tracking-wider rounded transition-all"
            >
              Sign In
            </button>
            <button
              onClick={handleSignUp}
              className="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-2 bg-gradient-to-r from-yellow-600 to-orange-600 hover:from-yellow-500 hover:to-orange-500 text-white font-orbitron font-bold text-xs sm:text-sm uppercase tracking-wider rounded transition-all shadow-lg"
            >
              Sign Up
            </button>
          </div>
        </div>
    </div>
  );
};

export default DemoConversionModal;
